import en from './en.js'
import zh from './zh.js'
export default {
  en,
  zh
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js